module.exports = __webpack_public_path__ + "img/deceleration.b0d849c9.svg";